type Options = {
  type: 'SELF' | 'PICKUP' | 'DELIVERY' | 'HOME_DELIVERY' | 'POINT' | 'PICKUP_POINT';
  title: string;
  price: string;
};

export const returnUnavailableDeliveryType = (options: Options[]): string | undefined => {
  const filteredDelivery = ['PICKUP_POINT', 'HOME_DELIVERY'].filter(
    (value) => !(options.map((el) => el.type) as string[]).includes(value),
  );

  if (filteredDelivery.length === 1) {
    return filteredDelivery[0];
  }
};
